import React, { Suspense, createContext, useContext, useMemo } from 'react'
import { SalesAgreement } from '../sales-agreements/storage'
const DrawdownRequestModal = React.lazy(() => import('./DrawdownRequestModal'))

export type DrawdownRequestType = SalesAgreement | null

export const DrawdownRequestContext = createContext<{
  setAgreement: (item: DrawdownRequestType) => void | null
  agreement: DrawdownRequestType
}>({
  setAgreement: () => null,
  agreement: null,
})

export const useDrawdownModal = () => useContext(DrawdownRequestContext)

type DrawdownProviderProps = {
  children?: React.ReactNode
}

export const DrawdownProvider: React.FC<DrawdownProviderProps> = ({ children }) => {
  const [agreement, setAgreement] = React.useState<DrawdownRequestType>(null)

  const setAgreementCallback = React.useCallback(
    (agreement: DrawdownRequestType) => {
      setAgreement(agreement)
    },
    [setAgreement],
  )

  const contextValue = useMemo(
    () => ({
      setAgreement: setAgreementCallback,
      agreement: agreement,
    }),
    [setAgreementCallback, agreement],
  ) // Wrap the object in a useMemo hook

  return (
    <DrawdownRequestContext.Provider value={contextValue}>
      {children}
      <Suspense fallback={null}>
        <DrawdownRequestModal />
      </Suspense>
    </DrawdownRequestContext.Provider>
  )
}

export default DrawdownProvider
